export class CreateCardOrderModel {
  public customerId: number;
  public productId: number;
  public comment: string;
  public cardType: number;
  public virtualOnly: boolean;
}
